import { UtilityService } from '../../services/utility.service';
import { ImageManagerService } from '../managers/image-manager.service';
import { ToroControllerBundle } from './toro-controller-bundle';

export class LXCControllerBundle extends ToroControllerBundle {
    constructor(json: any = null, protected imageManager: ImageManagerService) {
        super(json, imageManager);

        // if (json)
        // {
        //     // Map the json object to 'this' objects properties.
        //     Object.assign(this, json);
        // }
        //
        // if (json.Controller) this.Controller = new ToroController(json.Controller);
        // if (json.Configuration) this.Configuration = new ToroControllerConfiguration(json.Configuration);
        // if (json.CommCard) this.CommCard = new CommCardDetailed(json.CommCard);

        this.Controller.IsControllerSupported = true;
        this.Controller.RunningModeMaxIntervalDays = 14;
        this.showWaterBudgetForProgram = true;
        this.showMonthlyPercentAdjust = true;
        this.showClimateLogicSettings = false;
        this.showClimateLogicType = false;
        this.canUpdateNumberOfStations = !this.Controller.IsRecognized;
        this.showGetControllerConfiguration = true;
        this.showResyncCommCard = true;
        this.showImportConfiguration = true;
        this.showExportConfiguration = true;
        this.currentIntervalDayLabel = 'Current Day';
        //this.Configuration.MaximumStationRunTime = 1440;
        this.updateDryOutDaysList();
        this.updateFreezeOffTemperatureList();
    }

     // =========================================================================================================================================================
    // Station Runtime Info - Begin
    // =========================================================================================================================================================

    maxStationRuntimeInHours = 24;      //LXC max runtime for station

    get maxStationRuntimeInSeconds(): number
    {
        return this.maxStationRuntimeInHours * 60 * 60;
    }

    get maxStationRunTimeStringForProgram(): string
    {
        return `Max: ${Math.floor(this.maxStationRuntimeInHours)}h ${this.maxStationRuntimeInHours * 60 % 60}m`;
    }

    get maxStationRuntimeHourString(): string
    {
        return `${UtilityService.pad(Math.trunc(this.maxStationRuntimeInHours), 2)}:${Math.trunc((this.maxStationRuntimeInHours % 1) * 60)}`;
    }

    // =========================================================================================================================================================
    // Station Runtime Info - End
    // =========================================================================================================================================================


    public supportedLanguages = [
        { Text: 'English', Value: 0 },
        { Text: 'Spanish', Value: 1 } ,
        /*{ Text: 'French', Value: 2 },
        { Text: 'Italian', Value: 3 },
        { Text: 'German', Value: 4 }, */
        { Text: 'Portuguese', Value: 5 },
    ];

    /* public beginningOfWeekList = [
        { Text: 'Sunday', Value: 0 },
        { Text: 'Monday', Value: 1 }
    ]; */

    public temperatureScaleList = [
        { Text: '°F', Value: 0 },
        { Text: '°C', Value: 1 }
    ];

    public dateFormats = [
        { Text: 'MM/DD/YY', Value: 0 },
        { Text: 'DD/MM/YY', Value: 1 },
    ];

    public contrastList = this.getContrastList();

    public lengthUnitList = [
        { Text: 'Inches', Value: 0 },
        { Text: 'Meters', Value: 1 },
    ];

    public volumeUnitList = [
        { Text: 'GPM', Value: 0 },
        { Text: 'LPM', Value: 1 }
    ];

    public flowSensorUnit = [
        { Text: 'PPS', Value: 0 },
        { Text: 'GPM', Value: 1 },
        { Text: 'CFM', Value: 2 },
        { Text: 'CMM', Value: 3 },
        { Text: 'LPM', Value: 4 }
    ];

    public concurrentStationsList = [
        { Text: '1', Value: 0 },
        { Text: '2', Value: 1 },
        { Text: '3', Value: 2 },
        { Text: '4', Value: 3 }
    ];

    public ControllerRegion = [
        { Text: 'Us', Value: 0 },
        { Text: 'Europe', Value: 1 },
        { Text: 'Australia', Value: 3 }
    ];

    public LxcControllerLengthUnit = [
        { Text: 'Standard', Value: 0 },
        { Text: 'Metric', Value: 1 }
    ];

    public PastMidnight = [
        { Text: 'RunPastMidnightIntoWaterInactiveDay', Value: 0 },
        { Text: 'StopAtMidnightBeforeEnteringInactive', Value: 1 }
    ]

    /* public enum ControllerTimeFormat
    {
        TwelveHour = 0,
        TwentyFourHour = 1
    }

    public enum ConType
    {
        TMC424 = 0,
        TMC424E = 1,
        TMC212 = 2,
        EXTRASPRINKERTIMER = 3,
        CUTOMCOMMAND = 4,
        RAINDIAL = 5,
        TOTALCONTROL = 6,
        KWIKDIAL = 7,
        MC4E = 8,
        RAINDIAL132 = 9,
        RAINDIAL127 = 10,
        TOTALCONTROL73 = 11
    }

    public enum ZipOrLatLong
    {
        Zip = 0,
        LatLong = 1,
        NotSet = 2
    }*/

    getContrastList() {
        const list = [];
        for (let i = -15; i <= 15; i++) {
            list.push({ Text: this.formatContrastNumber(i), Value: i });
        }
        return list;
    }

    formatContrastNumber(num: number): string {
        if (num < 0) {
            return num.toString();
        }
        if (num > 0) {
            return '+' + num.toString();
        }
        return '0';

    }

    updateDryOutDaysList() {
        this.dryOutDaysList = [];
        this.dryOutDaysList.push({ Text: 'Off', Value: 0 });

        for (let i = 1; i <= 14; i++) {
            this.dryOutDaysList.push({ Text: i.toString(), Value: i });
        }
    }

    updateFreezeOffTemperatureList() {
        this.freezeOffTemperatureList = [];
        this.freezeOffTemperatureList.push({ Text: 'Off', Value: 0 });
        for (let i = 29; i <= 45; i += 2) {
            this.freezeOffTemperatureList.push({ Text: i.toString(), Value: i });
        }
    }
}
